if($('.products').length){
	function mhproduct(){
		$('.product').each(function(){
			$(this).find('.p').append('<span class="favorite"></span>')
			var havsleva = $(this).find('.flags-extra .flag-discount')
			var findpuvodnice = $(this).find('.flag-discount .price-standard')
			var findcena = $(this).find('.prices')
			var findavailability = $(this).find('.availability')
			//$(findavailability).appendTo($(this).find('.p-bottom>div'))
			var finddesc = $(this).find('.p-desc')
			var finddostuponost = $(this).find('.availability').text().replace(/\s+/g, " ").trim().replace(/^(.+?)\s+(\d+.*)$/, "$1 - $2").split(/[\(\>-]/)[0]
			var finddostuponost = finddostuponost.normalize('NFD').replace(/[^\w]/g, '').toLowerCase();
			var findflagextra = $(this).find('.flags-extra')
			var findflagdefault = $(this).find('.flags-default')
			var findvar = $(this).find('.widget-parameter-wrapper')
			if($(findvar).length == 1){
				$(this).find('.p-in').append(findvar)
			}
			if($(findvar).length == 0){
				$(this).find('.p-in').append('<div class="widget-parameter-wrapper-no"></div>')
			}
			if($(findflagdefault).length == 1){
				if($(findflagextra).length == 1){
					$(findflagdefault).append($(findflagextra).html())
				}
			}
			if($(findflagdefault).length == 0){
				if($(findflagextra).length == 1){
					$(findflagextra).addClass('nodefault')
				}
			}

			
			$(this).addClass(finddostuponost)
			$(this).attr('data-stock', finddostuponost)
			if($(havsleva).length){
				$(this).addClass('have-action')
				
				$(findcena).prepend(findpuvodnice);
				
			}
		});
		$('.availability-amount').each(function() {
			$(this).html(function(){
			   return $(this).html().replace("(", "");
		 })
		 $(this).html(function(){
			return $(this).html().replace(")", "");
	  })
	   });
		$(".products .product .flag-discount").each(function() {
   			$(this).html(function(){
      			return $(this).html().replace("od", "");
    		})
  		});
		 

	};
	mhproduct();;
	document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    	mhproduct();
	});
	$(document).on("ShoptetDOMAdvancedOrderLoaded",function(){
		mhproduct();	
	});
	document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    	mhproduct();

	});
}

$(window).on("load", function(){

		$('.product').each(function(){
			
		})
})
